import React, { useState, useEffect } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { Link, useLocation } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import "./styles.css";
import { getCurrentUserReports } from '../../db';

const Menu = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Initialize directly from localStorage to avoid null state issue
  const [optometristRole, setOptometristRole] = useState(() => {
    return localStorage.getItem("optometrist_role");
  });
  const [pendingCount, setPendingCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    // Get the optometrist role from localStorage (update if it changes)
    const role = localStorage.getItem("optometrist_role");
    setOptometristRole(role);
  }, []);

  // Check for pending data count
  useEffect(() => {
    const checkPendingCount = async () => {
      try {
        const pendingReports = await getCurrentUserReports();
        setPendingCount(pendingReports.length);
      } catch (error) {
        console.error('Error checking pending count:', error);
      }
    };
    
    checkPendingCount();
    // Check every 30 seconds
    const interval = setInterval(checkPendingCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const drawerList = (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      className="drawerContent"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" padding={2}>
        <Typography variant="h6" style={{ color: '#0820b4' }}>Menu</Typography>
        <IconButton onClick={toggleDrawer(false)} style={{ color: '#0820b4' }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        {/* Only show Dashboard if role is not Ophthalmologist */}
        {optometristRole && optometristRole !== "Ophthalmologist" && (
          <ListItem button component={Link} to="/dashboard">
            <ListItemIcon>
              <img src={location.pathname === "/dashboard" ? "/assests/images/dashboardSelected.svg" : "/assests/images/dashboard.svg"} alt="Dashboard" style={{ width: "100%", height: "100%" }} />
            </ListItemIcon>
          </ListItem>
        )}
        <ListItem button component={Link} to="/patientrecord">
          <ListItemIcon>
            <img src={location.pathname === "/patientrecord" ? "/assests/images/patientRecordSelected.svg" : "/assests/images/patientRecord.svg"} alt="Patient Record" style={{ width: "100%", height: "100%" }} />
          </ListItemIcon>
        </ListItem>
        {/* Only show Sync Data if role is not Ophthalmologist */}
        {optometristRole && optometristRole !== "Ophthalmologist" && (
          <ListItem button component={Link} to="/syncdata">
            <ListItemIcon>
              <img src={location.pathname === "/syncdata" ? "/assests/images/ActiveSync.svg" : "/assests/images/InactiveSync.svg"} alt="Sync Data" style={{ width: "100%", height: "100%" }} />
            </ListItemIcon>
          </ListItem>
        )}
        
        {/* <ListItem button component={Link} to="/syncdata" sx={{ padding: 0 }}>

        </ListItem> */}
        <ListItem button component={Link} to="/account">
          <ListItemIcon>
            <img src={location.pathname === "/account" ? "/assests/images/myAccountSelected.svg" : "/assests/images/myAccount.svg"} alt="Account" style={{ width: "100%", height: "100%" }} />
          </ListItemIcon>
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className="menuBar">
      <IconButton
        edge="start"
        color="inherit"
        aria-label="menu"
        onClick={toggleDrawer(true)}
        sx={{ display: { xs: "block", md: "none" } }}
      >
        <MenuIcon />
      </IconButton>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerList}
      </Drawer>
    </div>
  );
}

export default Menu;
